const state = {
    regions: [],
    region: null,
    categories: [],
}

export const getters = {
    regions: state => state.regions,
    region: state => state.region,
    categories: state => state.categories,
}


export const mutations = {
    regions(state, regions) {
        state.regions = regions
    },
    region(state, region) {
        state.region = region
    },
    categories(state, categories) {
        state.categories = categories
    },

}


export const actions = service => ({
    async fetchRegions({commit}) {
        commit('regions', await service.fetchRegions())
    },
    async fetchRegion({commit}, idRegion) {
        commit('region', await service.fetchRegion(idRegion))
    },
    async fetchCategories({commit}, idRegion) {
        commit('categories', await service.fetchCategories(idRegion))
    },
    // Auto-detect the user's region using IP geolocation,
    // falling back to the browser language if IP detection fails or finds no match.
    // If neither method resolves a region, the user will select one manually.
    async detectRegionByIp({state, dispatch}) {
        // Match a country code (e.g. "IT", "US") against available regions
        const findRegionByCountryCode = (code) => {
            if (!code || !state.regions) return null
            return state.regions.find(region =>
                region.countries && region.countries.includes(code)
            )
        }

        // 1. Try IP-based geolocation (ipapi.co)
        try {
            const countryCode = await service.fetchCountryCode()
            const matchedRegion = findRegionByCountryCode(countryCode)
            if (matchedRegion) {
                await dispatch('fetchRegion', matchedRegion.id)
                await dispatch('fetchCategories', matchedRegion.id)
                return
            }
        } catch (e) {
            // Network error or rate limit — fall through to browser language
        }

        // 2. Fallback: iterate browser language preferences (e.g. ["it", "it-IT", "en-US"])
        //    and match the first one that contains a country code
        const languages = navigator.languages || [navigator.language]
        for (const lang of languages) {
            if (lang && lang.includes('-')) {
                const code = lang.split('-')[1].toUpperCase()
                const matchedRegion = findRegionByCountryCode(code)
                if (matchedRegion) {
                    await dispatch('fetchRegion', matchedRegion.id)
                    await dispatch('fetchCategories', matchedRegion.id)
                    return
                }
            }
        }
    },
})

export default service => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(service)
})

